"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * keepkey-sdk-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesCoinToJSON = exports.TypesCoinFromJSONTyped = exports.TypesCoinFromJSON = exports.instanceOfTypesCoin = void 0;
const runtime_1 = require("../runtime");
const TypesHexBytesLower_1 = require("./TypesHexBytesLower");
const TypesNumericU32_1 = require("./TypesNumericU32");
const TypesNumericU64_1 = require("./TypesNumericU64");
/**
 * Check if a given object implements the TypesCoin interface.
 */
function instanceOfTypesCoin(value) {
    let isInstance = true;
    return isInstance;
}
exports.instanceOfTypesCoin = instanceOfTypesCoin;
function TypesCoinFromJSON(json) {
    return TypesCoinFromJSONTyped(json, false);
}
exports.TypesCoinFromJSON = TypesCoinFromJSON;
function TypesCoinFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nanoaddr_prefix': !(0, runtime_1.exists)(json, 'nanoaddr_prefix') ? undefined : json['nanoaddr_prefix'],
        'xpub_magic_segwit_native': !(0, runtime_1.exists)(json, 'xpub_magic_segwit_native') ? undefined : (0, TypesNumericU32_1.TypesNumericU32FromJSON)(json['xpub_magic_segwit_native']),
        'xpub_magic_segwit_p2sh': !(0, runtime_1.exists)(json, 'xpub_magic_segwit_p2sh') ? undefined : (0, TypesNumericU32_1.TypesNumericU32FromJSON)(json['xpub_magic_segwit_p2sh']),
        'decred': !(0, runtime_1.exists)(json, 'decred') ? undefined : json['decred'],
        'bech32_prefix': !(0, runtime_1.exists)(json, 'bech32_prefix') ? undefined : json['bech32_prefix'],
        'cashaddr_prefix': !(0, runtime_1.exists)(json, 'cashaddr_prefix') ? undefined : json['cashaddr_prefix'],
        'curve_name': !(0, runtime_1.exists)(json, 'curve_name') ? undefined : json['curve_name'],
        'force_bip143': !(0, runtime_1.exists)(json, 'force_bip143') ? undefined : json['force_bip143'],
        'segwit': !(0, runtime_1.exists)(json, 'segwit') ? undefined : json['segwit'],
        'xpub_magic': !(0, runtime_1.exists)(json, 'xpub_magic') ? undefined : (0, TypesNumericU32_1.TypesNumericU32FromJSON)(json['xpub_magic']),
        'contract_address': !(0, runtime_1.exists)(json, 'contract_address') ? undefined : (0, TypesHexBytesLower_1.TypesHexBytesLowerFromJSON)(json['contract_address']),
        'decimals': !(0, runtime_1.exists)(json, 'decimals') ? undefined : (0, TypesNumericU32_1.TypesNumericU32FromJSON)(json['decimals']),
        'forkid': !(0, runtime_1.exists)(json, 'forkid') ? undefined : (0, TypesNumericU32_1.TypesNumericU32FromJSON)(json['forkid']),
        'bip44_account_path': !(0, runtime_1.exists)(json, 'bip44_account_path') ? undefined : (0, TypesNumericU32_1.TypesNumericU32FromJSON)(json['bip44_account_path']),
        'signed_message_header': !(0, runtime_1.exists)(json, 'signed_message_header') ? undefined : json['signed_message_header'],
        'address_type_p2sh': !(0, runtime_1.exists)(json, 'address_type_p2sh') ? undefined : (0, TypesNumericU32_1.TypesNumericU32FromJSON)(json['address_type_p2sh']),
        'maxfee_kb': !(0, runtime_1.exists)(json, 'maxfee_kb') ? undefined : (0, TypesNumericU64_1.TypesNumericU64FromJSON)(json['maxfee_kb']),
        'address_type': !(0, runtime_1.exists)(json, 'address_type') ? undefined : (0, TypesNumericU32_1.TypesNumericU32FromJSON)(json['address_type']),
        'coin_shortcut': !(0, runtime_1.exists)(json, 'coin_shortcut') ? undefined : json['coin_shortcut'],
        'coin_name': !(0, runtime_1.exists)(json, 'coin_name') ? undefined : json['coin_name'],
    };
}
exports.TypesCoinFromJSONTyped = TypesCoinFromJSONTyped;
function TypesCoinToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nanoaddr_prefix': value.nanoaddr_prefix,
        'xpub_magic_segwit_native': (0, TypesNumericU32_1.TypesNumericU32ToJSON)(value.xpub_magic_segwit_native),
        'xpub_magic_segwit_p2sh': (0, TypesNumericU32_1.TypesNumericU32ToJSON)(value.xpub_magic_segwit_p2sh),
        'decred': value.decred,
        'bech32_prefix': value.bech32_prefix,
        'cashaddr_prefix': value.cashaddr_prefix,
        'curve_name': value.curve_name,
        'force_bip143': value.force_bip143,
        'segwit': value.segwit,
        'xpub_magic': (0, TypesNumericU32_1.TypesNumericU32ToJSON)(value.xpub_magic),
        'contract_address': (0, TypesHexBytesLower_1.TypesHexBytesLowerToJSON)(value.contract_address),
        'decimals': (0, TypesNumericU32_1.TypesNumericU32ToJSON)(value.decimals),
        'forkid': (0, TypesNumericU32_1.TypesNumericU32ToJSON)(value.forkid),
        'bip44_account_path': (0, TypesNumericU32_1.TypesNumericU32ToJSON)(value.bip44_account_path),
        'signed_message_header': value.signed_message_header,
        'address_type_p2sh': (0, TypesNumericU32_1.TypesNumericU32ToJSON)(value.address_type_p2sh),
        'maxfee_kb': (0, TypesNumericU64_1.TypesNumericU64ToJSON)(value.maxfee_kb),
        'address_type': (0, TypesNumericU32_1.TypesNumericU32ToJSON)(value.address_type),
        'coin_shortcut': value.coin_shortcut,
        'coin_name': value.coin_name,
    };
}
exports.TypesCoinToJSON = TypesCoinToJSON;
